export const qualtricsTags = {
  FEEDBACK: () => {
    return {
      event: 'feedback',
    };
  },
};
